<template>
  <div class="shadow-button">
    <slot>
    </slot>
  </div>
</template>

<script>
export default {
  name: "ShadowButton",
  setup() {},
};
</script>

<style lang="less" scoped>
.shadow-button {
  margin: @padding-sm 0;
  box-shadow: 0px 0px 6px #d6d6d6;
  border-radius: @radius-base;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: @font-size-lg;
  color: @light-black;
  .pointer();
}
</style>